import { useContext } from "react";
import { AlertManagerContext } from "~context/AlertManager";

export const useAlert = () => {
  const context = useContext(AlertManagerContext);
  return context.showAlert;
};
